import { Product } from "../../api/models"
import SkuName from "./SkuName"

// The product's name where it acts as a title: its logo when it has one,
// the plain text otherwise. Products carry the same name/logoUrl/
// logoAvailableWidths shape as skus (both logos are normalized by
// logoFrame.ts and sized by the same CSS heights), so SkuName does the
// rendering — this is the readable name for the product call sites.
export default function ProductName({ product, variant, sizes }: {
  product: Pick<Product, "name" | "logoUrl" | "logoAvailableWidths">
  variant: "title" | "section"
  sizes?: string
}) {
  return <SkuName sku={product} variant={variant} sizes={sizes} />
}
